import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from "jquery";

class Imprint extends Component {
	constructor(props) {
  		super(props);
  		this.state = {
  		};
  	}

  	handleClick(event)
  	{
  		$('.navbar-collapse').removeClass("show");
  	}

  	render() {
    	return (
	    		<div className="container marginTop50px">
            <div className="row">
              <div className="col-12">
                <div className="card borderNone">
                  <div className="card-body">
                    <h5 className="card-title">Impressum</h5>
                    <h6 className="card-subtitle mb-2 text-muted"></h6>
                    <p className="card-text">
                      Dipl.-&Ouml;konom
                      <br />
                      R&uuml;diger Heckmann
                      <br />
                      <br />
                      Inselstraße 11
                      <br />
                      40479 D&uuml;sseldorf
                      <br />
                      <br />
                      Telefon: 0211-5370700
                      <br />
                      Fax: 0211-5370773
                      <br />
                      <br />
                      <a className="colorBlack" href="mailto://r.heckmann@heckmann-steuerberatung.de" target="_blank">r.heckmann@heckmann-steuerberatung.de</a>
                      <br />
                      <a className="colorBlack" href="www.heckmann-steuerberatung.de" target="_self">www.heckmann-steuerberatung.de</a>
                      <br />  
                      <br />
                      Inhaltlich Verantwortlicher gem&auml;ß § 10 Absatz 3 MDStV:
                      R&uuml;diger Heckmann, Inselstraße 11, 40479 D&uuml;sseldorf
                      <br />
                      <br />
                      <br />
                      Ust-Nr: DE 199547196
                      <br />
                      <br />
                      Haftungshinweis:
                      <br />
                      Trotz sorgf&auml;ltiger inhaltlicher Kontrolle &uuml;bernehme ich keine Haftung f&uuml;r die Inhalte externer Links.
                      F&uuml;r den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
                    </p>
                  </div>
                </div>
              </div>
            </div>
	    		</div>
	    );
	}
}

export default Imprint;


// WEBPACK FOOTER //
// ./src/Imprint.js